import React from 'react';
import { SyncStatus as SyncStatusType } from '@/services/api';
import IndefiniteLoader from './IndefiniteLoader';

interface SyncStatusProps {
    status: SyncStatusType;
}

export const SyncStatus: React.FC<SyncStatusProps> = ({ status }) => {
    return (
        <div className="flex flex-col justify-center items-center w-full h-[calc(100vh-300px)] gap-6">
            <div className="max-w-2xl w-full text-center">
                <img className="w-[300px] h-[300px] mx-auto" src='/assets/processing.svg' />
                <h2 className="text-2xl font-bold text-white mb-4">
                    {status === 'PENDING'
                        ? "Posts are being synced"
                        : "Processing Your Posts"}
                </h2>

                {/* Horizontal Progress Bar */}
                <IndefiniteLoader className="my-6" />
                {/* <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-6">
                    <div
                        className="h-full bg-blue-500 rounded-full animate-pulse"
                        style={{ width: status === 'PENDING' ? '30%' : '70%' }}
                    ></div>
                </div> */}

                <p className="text-white mb-6">
                    {status === 'PENDING'
                        ? "Your posts are currently being synced through the Chrome extension. If you left the process incomplete, please sync your posts again using the extension."
                        : "Your posts have been synced and we are now processing and categorizing them for your usage. We'll send you an email once the process is complete!"}
                </p>
            </div>
        </div>
    );
}; 